export enum Taxation {
    PRE_TAX = 'Pre-tax',
    POST_TAX = 'Post-tax',
    NOT_APPLICABLE = 'Not applicable'
}